import React, { useContext } from 'react';
import { FaPlus, FaMinus, FaTrash, FaCheck } from 'react-icons/fa';
import { BASE_URL } from '../../../../BaseUrl';
import { currencySymbolLeft, getSystemSettings } from '../../../../functions/Functions';
import { SettingsContext } from '../../../../contexts/Settings';

const MenuItem = ({ item, cartItem, onAddToCart, isOrderPunchingEnabled, onRemoveFromCart, showImage = true }) => {

  const { generalSettings } = useContext(SettingsContext)

  const handleDisable = (foodItem) => {
    const isDisabled = !!((generalSettings &&
      parseInt(getSystemSettings(generalSettings, "fgs_enable")) === 1 &&
      (foodItem?.available_qty <= 0 || foodItem?.available_qty === undefined) &&
      foodItem?.is_deal === 0 && !foodItem?.is_recipe))
    return isDisabled;
  }

  const Isshowtags = (foodItem) => {
    return (
      generalSettings &&
      parseInt(getSystemSettings(generalSettings, "fgs_enable")) === 1 &&
      foodItem?.is_deal === 0 &&
      !foodItem?.is_recipe
    );
  };

  const renderStockQty = (foodItem) => {
    if (!foodItem) return null;

    if (foodItem?.available_qty <= 0 || foodItem?.available_qty === undefined) {
      return (
        <span className="modern-tag out-of-stock" >Out of stock</span>
      );
    } 
    // else {
    //   return (
    //     <span className="modern-tag in-stock" > Qty : {" " + Number(foodItem?.available_qty)}</span>
    //   );
    // }
  }

  return (
    <div 
      className={`modern-item-card cursor-pointer bg-white d-flex flex-column ${handleDisable(item) ? "disabled" : ""}`}
      onClick={() => onAddToCart(item)}
    >
      {/* Omit the whole image area when disabled so no blank or fallback block remains. */}
      {showImage && <div className="item-image-wrapper position-relative">
        <img
          src={item.image ? BASE_URL + item.image : "/assets/img/default-item.jpeg"} 
          alt={item.name} 
          className="item-image" 
          loading="lazy"
          onError={(e) => { e.target.onerror = null; e.target.src = "/assets/img/default-item.jpeg" }}
        />
        {Isshowtags(item) &&
          <div className="modern-tag-overlay">
            {renderStockQty(item)}
          </div>
        }
        {cartItem && cartItem.quantity > 0 && (
          <div className="position-absolute" style={{ top: '8px', left: '8px', zIndex: 5 }}>
            <span className="badge bg-white text-dark shadow-sm d-flex align-items-center px-2 py-1 rounded-pill item-in-cart-badge">
               <FaCheck className="text-success mr-1 item-in-cart-icon" /> {cartItem.quantity} in cart
            </span>
          </div>
        )}
      </div>}
      <div className="item-details flex-grow-1 d-flex flex-column text-left text-start">
        <div className="item-name-wrapper">{item.name}</div>
        <div className="item-price-wrapper mt-auto mb-2">
          <span className="">{currencySymbolLeft()} {(item?.has_variation === "1" && Array.isArray(item.variations)) ? item.variations[0]?.food_with_variation_price : item.price}</span>
        </div>
        
        {
          isOrderPunchingEnabled ? (
            <div className="menu-action-container mt-2">
                {!cartItem ? (
                  <button 
                    className="btn w-100 rounded-pill shadow-sm d-flex align-items-center justify-content-center add-btn-outline" 
                    onClick={(e) => { e.stopPropagation(); onAddToCart(item); }}
                  >
                    <FaPlus className="mr-2" /> <span className="font-weight-bold">Add</span>
                  </button>
                ) : (
                  <div className="d-flex align-items-center justify-content-between rounded-pill shadow-sm add-btn-filled w-100">
                    <button className="btn border-0 text-white d-flex align-items-center justify-content-center action-btn-left" onClick={(e) => { e.stopPropagation(); onRemoveFromCart(item); }}>
                      {cartItem.quantity === 1 ? <FaTrash /> : <FaMinus />}
                    </button>
                    <span className="font-weight-bold text-white cart-quantity-text-main">
                      {cartItem.quantity}
                    </span>
                    <button className="btn border-0 text-white d-flex align-items-center justify-content-center action-btn-right" onClick={(e) => { e.stopPropagation(); onAddToCart(item); }}>
                      <FaPlus />
                    </button>
                  </div>
                )}
            </div>
          ) : null
        }
      </div>
    </div>
  );
};

export default MenuItem;
